import { ReactNode, createContext } from 'react';

import { ListSize } from '../ListBoxBase/types';
import { TextPresetWithSkin } from '../TextGeneric/types';

interface ListContextType {
    size: ListSize;
    onItemClick?: () => void;
}

export const ListContext = createContext<ListContextType>({ size: 'm' });

interface VirtualListItemContextType {
    isFirst: boolean;
    isLast: boolean;
}

export const VirtualListItemContext = createContext<VirtualListItemContextType>({ isFirst: false, isLast: false });

interface ListSearchContextType {
    query: string;
    isActive: boolean;
}

export const inactiveListSearchContextValue: ListSearchContextType = { query: '', isActive: false };

export const ListSearchContext = createContext<ListSearchContextType>(inactiveListSearchContextValue);

export function getTextPresetWithSkin(option?: { caption?: ReactNode }): TextPresetWithSkin {
    return option?.caption ? 'current-main + current-caption' : 'current-main';
}
